import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  city: EventEmitter<string> = new EventEmitter<string>();
  userLoggedIn: EventEmitter<string> = new EventEmitter<string>();
  userLoggedOut: EventEmitter<string> = new EventEmitter<string>();

  // device identification
  public deviceInfo;
  public isMobile;
  public isDesktopDevice;
  public isTablet;

  constructor(
    private http: HttpClient,
    private deviceService: DeviceDetectorService,
    private meta: Meta,
    private titleService: Title,
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();

  }

  updateMeta(pageSlug, product): void {
    // Google analytics
    // this.$gaService.pageView('/experience/' + pageSlug, product.details.seo_title);

    // page metas
    this.meta.updateTag({name: 'description', content: product.details.description});
    this.meta.updateTag({name: 'copyright', content: 'Things2do'});
    this.meta.updateTag({name: 'robots', content: 'index,follow'});
    this.titleService.setTitle(product.details.seo_title);

    // meta tags
    this.meta.updateTag({property: 'og:url', content: ''});
    this.meta.updateTag({property: 'og:title', content: product.details.seo_title});
    this.meta.updateTag({property: 'og:description', content: product.details.seo_description});
    this.meta.updateTag({property: 'og:image', content: product.details.seo_image});

    // twitter cards
    this.meta.updateTag({property: 'twitter:card', content: 'summary'});
    this.meta.updateTag({property: 'twitter:site', content: '@things2do'});
    this.meta.updateTag({property: 'twitter:title', content: product.details.seo_title});
    this.meta.updateTag({property: 'twitter:description', content: product.details.seo_description});
    this.meta.updateTag({property: 'twitter:image', content: product.details.seo_image});
  }


  getDisplayName(): string {
    if (localStorage.getItem('first_name') != null) {
      return localStorage.getItem('first_name') || '' + ' ' + localStorage.getItem('last_name') || '';
    }

  }

  cityChanged(city): void {
    this.setlocationSetByTheUser();

    localStorage.removeItem('product');
    localStorage.removeItem('deal');

    this.city.emit(city);
  }

  triggerUserLoggedIn(): void {
    this.userLoggedIn.emit('loggedIn');
  }

  triggerUserLoggedOut(): void {
    this.userLoggedOut.emit('loggedOut');
  }

  getCurrentCity(actual = false): string {

    // console.log('Token', this.getAccessToken());

    if (actual) {
      return localStorage.getItem('city') ?? '';
    } else {
      return localStorage.getItem('city') ?? 'Mumbai';
    }
  }

  getAccessToken(): string {
    return localStorage.getItem('accessToken');
  }

  islocationSetByTheUser(): boolean {
    if (localStorage.getItem('userSetLocation') !== null && localStorage.getItem('userSetLocation') === '1') {
      return true;
    } else {
      return false;
    }
  }


  setlocationSetByTheUser(): void {
    localStorage.setItem('userSetLocation', '1');
  }

  getUserDetails(): object {
    const userDetails = {first_name: '', last_name: '', mobile_number: '', email: '', city: ''};
    userDetails.first_name = localStorage.getItem('first_name') || 'Guest';
    userDetails.last_name = localStorage.getItem('last_name');
    userDetails.email = localStorage.getItem('email');
    userDetails.city = localStorage.getItem('city');
    userDetails.mobile_number = localStorage.getItem('mobile_number');


    return userDetails;
  }

  addToWishlist(productID): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.http.post<any>(environment.domain + '/api/wishlist', {product_id: productID}, httpOptions).subscribe(
      data => {
        return data;
      },
      error => {
        return error;
      });
  }

  removeFromWishlist(productID): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.http.post<any>(environment.domain + '/api/remove-wishlist', {product_id: productID}, httpOptions).subscribe(
      data => {
        return data;
      },
      error => {
        return error;
      });
  }

  setUTMTrackingStorage(params) {
    var hasProperty = false;
    var t2d_utm: any = {};
    for (var property in params) {
      if (property.toString().startsWith('utm_')) {
        hasProperty = true;
        t2d_utm[property] = params[property];
        t2d_utm['created_at'] = new Date();

      }
    }
    if (hasProperty) {
      localStorage.setItem('t2d_utm', JSON.stringify(t2d_utm));
    } else {
      this.expireUTMTrackingStorage();
    }
  }

  expireUTMTrackingStorage() {
    var ls = this.getUTMTrackingStorage();
    if (ls) {
      var lso = JSON.parse(ls);
      if (lso) {
        var currentDateTime = new Date();
        var strogareDateTime = Date.parse(lso.created_at);
        var strogareDateTime1 = new Date(strogareDateTime);
        strogareDateTime1.setDate(strogareDateTime1.getDate() + 5);
        if (currentDateTime > strogareDateTime1) {
          localStorage.removeItem('t2d_utm');
        }
      }
    }
  }

  getUTMTrackingStorage() {
    return localStorage.getItem('t2d_utm');
  }


}
